<template>
  <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" style="background-color: rgba(0,0,0,0.5);">
    <div class="modal-dialog modal-lg" style="width:90vw; min-height: 80vh">
      <div class="modal-content " style="margin: 0 auto; height:100%">
        <div class="modal-header w-100">
          <div class="float-left upload-lf">zugewiesene Benutzer zu Projekt {{projectitem.name}} ({{projectitem.shortname}})</div>
          <div class="float-right">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closemodal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <div class="modal-body upload-body" style="height:80vh; overflow: auto">
          <table class="w-100 table ">
            <thead>
              <tr>
                <th></th>
                <th>E-Mail</th>
                <th>Vorname</th>
                <th>Nachname</th>
                <th>Firma</th>
                <th>Rechte</th>
                <th>zugewiesen am</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in userlist">
                <td>{{ item.pduserid }}</td>
                <td>{{ item.email }}</td>
                <td>{{ item.firstname }}</td>
                <td>{{ item.lastname }}</td>
                <td>{{ item.company }}</td>
                <td>
                  <select name="" v-model="item.pdroleid" class="form-control form-control-sm" @change="setUserProjectRole($event, item)">
                    <option :value="0">Ersteller</option>
                    <option :value="1">Admin</option>
                    <option :value="2">Benutzer</option>
                    <option :value="3">Gast</option>
                  </select>
                </td>
                <td>{{ getdateadded(item) }}</td>
                <td>
                  <div class="switch ">
                    <label class="">
                      <input type="checkbox" :id="'creator' + item.pduserid" class="custom-control-input" v-model="item.active" :true-value="1" :false-value="2" @change="setUserProjectStatus($event, item)">
                      <span class="lever float-right mr-0"></span>
                    </label>
                  </div>
                </td>
                <td>
                  <a href="#" @click="removeUserFromProject(item)"><i class="fa fa-trash"></i></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import axios from 'axios'
import moment from 'moment/moment'

export default {
  data () {
    return {
      'customeruserprojects': [],
      localtoast: null,
      userlist: []
    }
  },
  props: ['projectitem', 'showmodal', 'customerid'],
  mounted () {
    console.log('Modal Mounted!')
    this.getUsersOfProject()
  },
  methods: {
    async removeUserFromProject(item) {
      let _this = this

      if (confirm('Sicher das sie den Benutzer ' + item.email + ' von dem Projekt entfernen wollen?')) {
        await axios.post(process.env.VUE_APP_BASE_AMF_URL + `&token=` + localStorage.sessiontoken, {
          parameters: [_this.customerid, item.projectid, item.pduserid],
          serviceName: "ProjectdocuCustomer",
          methodName: "removeuserfromproject"
        }, {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        }).then(response => {
          console.log('RESP', response)
          if(response.data == true) {
            _this.localtoast = _this.$toast(
              'Gespeichert.',
              {
                timeout: 2000,
                closeOnClick: true,
                toastClassName: "savenote",
              }
            )
            _this.getUsersOfProject()
          }
        }).catch(e => {
          console.log('ERROR EXECUTION')
        });
      }



    },
    closemodal() {
      this.$emit('closeModal')
    },
    getdateadded(item) {
      let returndate = moment(item.added)
      if(!returndate.isValid()) {
        returndate = moment(item.created)
      }
      return returndate.format('DD.MM.YYYY')
    },

    async setUserProjectStatus(event, item) {
      console.log('SetProjectStatus', this.customerid, item)
      let _this = this
      await axios.post(process.env.VUE_APP_BASE_AMF_URL + `&token=` + localStorage.sessiontoken, {
        parameters: [_this.customerid, item.projectid, item.pduserid, item.active],
        serviceName: "ProjectdocuCustomer",
        methodName: "setCustomerUserProjectActive"
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {
        console.log('RESP', response)
        if(response.data == true) {
          _this.localtoast = _this.$toast(
            'Gespeichert.',
            {
              timeout: 2000,
              closeOnClick: true,
              toastClassName: "savenote",
            }
          )
        }
      }).catch(e => {
        console.log('ERROR EXECUTION')
      });
    },

    async setUserProjectRole(event, item) {
      console.log('SetProjectStatus', this.customerid, item)
      let _this = this
      await axios.post(process.env.VUE_APP_BASE_AMF_URL + `&token=` + localStorage.sessiontoken, {
        parameters: [_this.customerid, item.projectid, item.pduserid, item.pdroleid],
        serviceName: "ProjectdocuCustomer",
        methodName: "setCustomerProjectRole"
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {
        console.log('RESP', response)
        if(response.data == true) {
          _this.localtoast = _this.$toast(
            'Gespeichert.',
            {
              timeout: 2000,
              closeOnClick: true,
              toastClassName: "savenote",
            }
          )
        }
      }).catch(e => {
        console.log('ERROR EXECUTION')
      });
    },


    async getUsersOfProject() {
      let _this = this
      console.log('get CustomerUserProjects', this.customerid, _this.projectitem.projectid)

      await axios.post(process.env.VUE_APP_BASE_AMF_URL + `&token=` + localStorage.sessiontoken, {
        parameters: [_this.customerid, _this.projectitem.projectid],
        serviceName: "ProjectdocuCustomer",
        methodName: "getprojectusers"
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {
        _this.userlist = response.data.userlist
      }).catch(e => {
        console.log('ERROR EXECUTION')
      });
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/customer/components/UserlistModal.vue